<template>
  <div>
    <div class="corzo-page-title-wrap corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr">
          <div class="corzo-page-caption">Partner</div>
          <h1 class="corzo-page-title">成为城市合伙人</h1>
          <div class="corzo-page-caption-divider"></div>
        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #f5f5f5;"></div>
      <div class="gdlr-core-pbf-background-wrap" style="top: 350px;">
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-image: url(upload/hp2-about-bg.png); background-repeat: no-repeat; background-position: top center;" data-parallax-speed="0"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first" id="gdlr-core-column-2049">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: 0px -30px 0px 0px; padding: 105px 40px 140px 0px; height: 665.492px;" data-sync-height="height-00">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-image: url(upload/square00.png); background-size: cover; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr" style="padding-bottom: 0px;">
                    <div class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle" style="border-width: 0px;">
                      <img src="http://cdn-static.huidetrust.com/static/images/2023072801.png" alt="" width="601" height="398" title="汇德">
                    </div>
                  </div>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #090909;">
                      <p>

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-column gdlr-core-column-30" id="gdlr-core-column-76282">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: 0px 0px 0px 30px; padding: 115px 0px 0px 50px; height: 665.492px;" data-sync-height="height-00">
              <div class="gdlr-core-pbf-background-wrap">
                <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style="background-repeat: no-repeat; background-position: center;" data-parallax-speed="0"></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                                                        <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption" style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                                                            <span class="gdlr-core-title-item-left-dot" style="width: 5px; height: 5px; background-color: #d32525; margin-right: 13px;"></span>Huide Group
                                                        </span>
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #090909;">
                        什么是城市合伙人<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #090909;">
                      <p>
                        城市合伙人是向“匯德香港”的各个业务线推荐客户的个人或公司。
                      </p>
                      <br/>
                      <br/>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #090909;">
                        “匯德香港”城市合伙人发展支持
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space">
                    <div class="gdlr-core-text-box-item-content" style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #090909;">
                      <p>
                        这里，不仅有你的努力前行，更有我们的齐心协力，我们期待与您共同收获价值与成长。

                      </p>
                      <br/>
                      <br/>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="gdlr-core-pbf-wrapper" style="padding: 90px 0px 35px 0px;">
      <div class="gdlr-core-pbf-background-wrap" style="background-color: #ffffff;"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first">
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" style="max-width: 760px;">
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr" style="padding-bottom: 60px;">
                    <div class="gdlr-core-title-item-title-wrap">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title" style="font-size: 39px; font-weight: 600; letter-spacing: 0px; text-transform: none;">
                        现在申请 加入我们 <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                    <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption" style="font-size: 19px; font-style: normal;">匯德香港城市合作人申请</span>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div class="gdlr-core-contact-form-7-item gdlr-core-item-pdlr gdlr-core-item-pdb">
                    <div role="form" class="wpcf7" id="wpcf7-f1979-p1964-o1" lang="en-US" dir="ltr">
                      <div class="screen-reader-response">
                        <p role="status" aria-live="polite" aria-atomic="true"></p>
                        <ul></ul>
                      </div>
                      <form>

                        <input type="text" name="姓名" placeholder="姓名:" v-model="form.name" class="input">

                        <input type="text" name="手机号" placeholder="手机号:" v-model="form.phone" class="input">

                        <input type="text" name="Email" placeholder="Email:" v-model="form.email" class="input">

                        <input type="text" name="申请工作城市" placeholder="申请工作城市:" v-model="form.city" class="input">

                        <input type="button" value="申请" class="submit-button" :disabled="isApply" @click="apply()">
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Partner',
  data () {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        city: ''
      },
      isApply: false
    }
  },
  methods: {
    apply () {
      if (this.form.name.length === 0) {
        alert('请填写姓名')
        return false
      }
      if (this.form.phone.length === 0) {
        alert('请填写手机号')
        return false
      }
      if (this.form.email.length === 0) {
        alert('请填写Email')
        return false
      }
      if (this.form.city.length === 0) {
        alert('请填写城市')
        return false
      }
      if (!this.isMobile(this.form.phone)) {
        alert('请确认手机号')
        return false
      }
      // if (!this.isEmail(this.form.email)) {
      //   alert('请确认邮箱')
      //   return false
      // }
      this.isApply = true
      axios.post('/mail/mail.php?token=KWYTuBLt7eSQPDJc', {
        title: '城市合伙人',
        form: [
          '姓名: ' + this.form.name,
          '手机号: ' + this.form.phone,
          'email: ' + this.form.email,
          '城市: ' + this.form.city
        ]
      }).then(res => {
        this.isApply = false
        if (res.data.code === 200) {
          alert('发送成功')
          return false
        }
      })
      console.log(this.form)
    },
    isMobile (mobile) {
      return /^1[3-9]\d{9}$/.test(mobile)
    },
    isEmail (email) {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Partner.vue